import { ApiError } from '../../api/client';

export function Loading({ height = 120 }: { height?: number }) {
  return <div className="skeleton" style={{ height }} aria-label="Loading" />;
}

export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const e = error as ApiError;
  const msg = e?.code === 'FORBIDDEN' ? 'Your role does not have access to this data.' : e?.message || 'Something went wrong';
  return (
    <div className="state error" role="alert">
      <div>{msg}</div>
      {onRetry && (
        <button className="btn sm" style={{ marginTop: 10 }} onClick={onRetry}>
          Retry
        </button>
      )}
    </div>
  );
}

export function Empty({ children }: { children: React.ReactNode }) {
  return <div className="state">{children}</div>;
}
